module.exports = "/work-site/img/bigdata.4c27a641.png";